import { Paper } from "@mui/material";
import { Email, MenuBook, PeopleAlt, Settings, SignalCellularAlt, Storefront } from "@mui/icons-material";
import { Link as RouterLink } from "react-router-dom";
import { FormattedMessage } from "react-intl";

import { useUser } from "@dzambalaorg/provider-user";
import { IUser, UserRole } from "@framework/types";
import { List } from "@dzambalaorg/ui-kit";

const data = [
  { text: "pages.dashboard.infrastructure.admin.users", link: "/users", icon: <PeopleAlt /> },
  { text: "pages.dashboard.infrastructure.admin.settings", link: "/settings", icon: <Settings /> },
  { text: "pages.dashboard.infrastructure.admin.pages", link: "/pages", icon: <MenuBook /> },
  { text: "pages.dashboard.infrastructure.admin.emails", link: "/emails", icon: <Email /> },
  { text: "pages.dashboard.infrastructure.admin.merchants", link: "/merchants", icon: <Storefront /> },
  { text: "pages.dashboard.infrastructure.admin.rate-plans", link: "/rate-plans", icon: <SignalCellularAlt /> },
];

export const AdminSection = () => {
  const { profile } = useUser<IUser>();

  if (!profile.userRoles.includes(UserRole.ADMIN)) {
    return null;
  }

  return (
    <Paper sx={{ mb: 2 }}>
      <List
        component="nav"
        subheader={
          <List.Subheader>
            <FormattedMessage id="pages.dashboard.infrastructure.admin.title" />
          </List.Subheader>
        }
      >
        {data.map(({ text, icon, link }) => (
          <List.ItemButton<typeof RouterLink> key={text} component={RouterLink} to={link}>
            <List.ItemIcon>{icon}</List.ItemIcon>
            <List.ItemText>
              <FormattedMessage id={text} />
            </List.ItemText>
          </List.ItemButton>
        ))}
      </List>
    </Paper>
  );
};
